import { combineReducers } from 'redux';
import dynamicViewReducers from './slice';

export const reducer = combineReducers({
  dynamicViews: dynamicViewReducers,
});
